import { unleashClient } from '../unleash-client';
import store from '../store';
import localFlagValue from '../components/FeatureFlag';

export const getFlagValue = (flag: string): boolean => {
  const name = `${process.env?.REACT_APP_BASE_URL}_${flag}`;

  if (process.env.REACT_APP_USE_UNLEASH === 'true') {
    return unleashClient.isEnabled(name);
  }

  return localFlagValue(store.getState().user.email, name);
};
